import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuTabChangeService {
  public refreshData: Subject<string> = new Subject();
}
